import TranscriptComponent from './TranscriptComponent';

export default TranscriptComponent;
